import _createClass from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import { BlockCipherMode } from './cipher-core.js';

var incWord = function incWord(word) {
  var _word = word;

  if ((word >> 24 & 0xff) === 0xff) {
    // overflow
    var b1 = word >> 16 & 0xff;
    var b2 = word >> 8 & 0xff;
    var b3 = word & 0xff;

    if (b1 === 0xff) {
      // overflow b1
      b1 = 0;

      if (b2 === 0xff) {
        b2 = 0;

        if (b3 === 0xff) {
          b3 = 0;
        } else {
          b3 += 1;
        }
      } else {
        b2 += 1;
      }
    } else {
      b1 += 1;
    }

    _word = 0;
    _word += b1 << 16;
    _word += b2 << 8;
    _word += b3;
  } else {
    _word += 0x01 << 24;
  }

  return _word;
};

var incCounter = function incCounter(counter) {
  var _counter = counter;
  _counter[0] = incWord(_counter[0]);

  if (_counter[0] === 0) {
    // encr_data in fileenc.c from  Dr Brian Gladman's counts only with DWORD j < 8
    _counter[1] = incWord(_counter[1]);
  }

  return _counter;
};
/** @preserve
 * Counter block mode compatible with  Dr Brian Gladman fileenc.c
 * derived from CryptoJS.mode.CTR
 * Jan Hruby jhruby.web@gmail.com
 */


export var CTRGladman = /*#__PURE__*/function (_BlockCipherMode) {
  _inherits(CTRGladman, _BlockCipherMode);

  var _super = _createSuper(CTRGladman);

  function CTRGladman() {
    _classCallCheck(this, CTRGladman);

    return _super.apply(this, arguments);
  }

  return CTRGladman;
}(BlockCipherMode);

CTRGladman.Encryptor = /*#__PURE__*/function (_CTRGladman) {
  _inherits(_class, _CTRGladman);

  var _super2 = _createSuper(_class);

  function _class() {
    _classCallCheck(this, _class);

    return _super2.apply(this, arguments);
  }

  _createClass(_class, [{
    key: "processBlock",
    value: function processBlock(words, offset) {
      var _words = words; // Shortcuts

      var cipher = this._cipher;
      var blockSize = cipher.blockSize;
      var iv = this._iv;
      var counter = this._counter; // Generate keystream

      if (iv) {
        this._counter = iv.slice(0);
        counter = this._counter; // Remove IV for subsequent blocks

        this._iv = undefined;
      }

      incCounter(counter);
      var keystream = counter.slice(0);
      cipher.encryptBlock(keystream, 0); // Encrypt

      for (var i = 0; i < blockSize; i += 1) {
        _words[offset + i] ^= keystream[i];
      }
    }
  }]);

  return _class;
}(CTRGladman);

CTRGladman.Decryptor = CTRGladman.Encryptor;